import {AbstractControl, ValidatorFn} from '@angular/forms';

export const conditionalValidator = (predicate, validator: ValidatorFn): ValidatorFn => ((control: AbstractControl) => {
    if (predicate()) {
        return validator(control);
    }
    return null;
});
